import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import Transparency from "./pages/Transparency";
import Impact from "./pages/Impact";
import Editions from "./pages/Editions";
import Create from "./pages/Create";
import Checkout from "./pages/Checkout";
import Dashboard from "./pages/Dashboard";
import RegistryDetail from "./pages/RegistryDetail";
import CertificatePage from "./pages/CertificatePage";
import Verify from "./pages/Verify";
import Explore from "./pages/Explore";
import Auth from "./pages/Auth";
import AuthCallback from "./pages/AuthCallback";
import Admin from "./pages/Admin";

const Protected = ({ children, adminOnly }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="py-40 text-center text-slate-500 text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/transparency" element={<Transparency />} />
        <Route path="/impact" element={<Impact />} />
        <Route path="/editions" element={<Editions />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/create" element={<Create />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/verify/:registryId" element={<Verify />} />
        <Route path="/registry/:registryId" element={<RegistryDetail />} />
        <Route path="/certificate/:registryId" element={<Protected><CertificatePage /></Protected>} />
        <Route path="/checkout/:registryId" element={<Protected><Checkout /></Protected>} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
        <Route path="/login" element={<Auth mode="login" />} />
        <Route path="/signup" element={<Auth mode="signup" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" theme="dark" richColors offset={96} />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
